import { Autocomplete, Box, TextField } from '@mui/material';

export default function AnprintVariantPicker({ variants, valueSku, onChange, disabled }) {
  const value = (variants || []).find((v) => String(v.sku) === String(valueSku)) || null;

  return (
    <Autocomplete
      disabled={disabled}
      size="small"
      sx={{ minWidth: 280, flex: 1 }}
      options={variants || []}
      value={value}
      onChange={(_, variant) => onChange(variant || null)}
      getOptionLabel={(v) => v.label || v.sku || ''}
      isOptionEqualToValue={(a, b) => String(a?.sku) === String(b?.sku)}
      filterOptions={(options, state) => {
        const q = String(state.inputValue || '').trim().toLowerCase();
        if (!q) return options;
        return options.filter((variant) => {
          const hay = `${variant.sku || ''} ${variant.catalogName || ''} ${variant.size || ''} ${variant.color || ''} ${variant.name || ''}`.toLowerCase();
          return hay.includes(q);
        });
      }}
      noOptionsText="Không có SKU"
      ListboxProps={{ style: { maxHeight: 280 } }}
      renderOption={(props, variant) => (
        <Box
          component="li"
          {...props}
          key={variant.sku}
          sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.25, py: 1, px: 1.5 }}
        >
          <Box component="span" sx={{ fontSize: 13, lineHeight: 1.35, fontWeight: 600 }}>
            {variant.sku}
          </Box>
          <Box component="span" sx={{ fontSize: 11, color: '#64748b' }}>
            {variant.catalogName} · {variant.size || '—'} / {variant.color || '—'}
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`Gõ SKU / size / color (${(variants || []).length} SKU)...`}
        />
      )}
    />
  );
}
